module.exports = __webpack_public_path__ + "static/3t-4f981115a67fe80cf1540bcf5d81e607.webp";